// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { AuthentifiedUser } from "../../api/backend-openapi";

export const authentifiedUserEvent = createEvent<
  AuthentifiedUser | undefined
>();

export const logout = createEvent<void>();
